// removed by extract-text-webpack-plugin
module.exports = {"modal":"bookmark__modal","vis-list-empty":"bookmark__vis-list-empty","bookmark-list-util":"bookmark__bookmark-list-util"};


//////////////////
// WEBPACK FOOTER
// ./src/components/bookmark/bookmark.scss
// module id = 1210
// module chunks = 0